<template>
  <v-app>
    <notifications
      group="app"
      animation-type="velocity"
    >
      <template
        slot="body"
        slot-scope="props"
      >
        <v-alert
          :type="props.item.type"
          :icon="props.item.data.icon"
          width="400"
          class="my-notification ma-3 mb-0"
        >
          <div class="d-flex align-center ml-3">
            <div class="my-notification__text body-2 mr-auto">
              {{ props.item.text }}
            </div>
            <v-btn
              icon
              x-small
              class="ml-0"
              @click="props.close"
            >
              <v-icon small>
                fa-times
              </v-icon>
            </v-btn>
          </div>
        </v-alert>
      </template>
    </notifications>

    <v-navigation-drawer
      v-if="$route.name !== 'logout'"
      v-model="appDrawer"
      app
      clipped
      :permanent="!appDrawer && !$vuetify.breakpoint.smAndDown"
      :expand-on-hover="!appDrawer && !$vuetify.breakpoint.smAndDown"
      mobile-break-point="960"
    >
      <template v-if="$_myUserData.isAuthed">
        <v-list class="py-0">
          <v-list-item class="px-2">
            <template>
              <v-list-item-avatar color="grey lighten-4">
                <v-img
                  v-if="$_myUserData.photoURL"
                  :src="$_myUserData.photoURL"
                />
                <v-icon
                  v-else
                  size="20"
                >
                  fa-user
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-title>{{ $_myUserData.displayName }}</v-list-item-title>
            </template>
          </v-list-item>
        </v-list>
        <v-divider />
      </template>
      <v-list
        nav
        dense
      >
        <template v-for="tab in drawerTabs">
          <v-list-item
            v-if="!(tab.onlyPublic || tab.requiresAuth) ||
              (tab.onlyPublic && !$_myUserData.isAuthed) ||
              (tab.requiresAuth && $_myUserData.isAuthed)"
            :key="tab.title"
            :to="tab.route"
            :class="{
              'no-select-list': tab.route.name === 'user-page' && $route.params.userId !== $_myUserData.uid
            }"
          >
            <v-list-item-icon>
              <v-icon size="20">
                {{ tab.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ tab.title }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
      <v-divider />
      <v-card
        v-if="appDrawer"
        flat
      >
        <v-card-subtitle style="width: max-content;">
          <div>
            <span>製作者：たそ（<a
              href="https://twitter.com/taso0096"
              target="_blank"
              rel="noopener"
            >@taso0096</a>）</span>
          </div>
          <div>
            <span>&copy;2020&nbsp;</span>
            <span class="font-weight-bold">midies</span>
          </div>
        </v-card-subtitle>
      </v-card>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
      color="white"
      elevation="3"
    >
      <v-app-bar-nav-icon
        v-if="$route.name !== 'logout'"
        @click="appDrawer = !appDrawer"
      >
        <v-icon>fas fa-bars</v-icon>
      </v-app-bar-nav-icon>
      <v-btn
        text
        :ripple="false"
        :to="{ name: 'home' }"
        class="d-none d-sm-block not-hover-btn pa-0"
      >
        <v-toolbar-title class="d-flex align-center pl-1">
          <span class="rolachan display-1">midies</span>
          <template v-if="showTitlePages.includes($route.name) || $route.name === 'user-page' && $route.params.userId !== $_myUserData.uid">
            <span class="headline mx-2">|</span>
            <span class="headline">{{ $route.meta.displayName }}</span>
          </template>
        </v-toolbar-title>
      </v-btn>
      <v-toolbar-title class="mobile-title d-block d-sm-none pl-1">
        <span
          v-if="$route.meta.displayName === 'midies'"
          class="rolachan display-1"
        >midies</span>
        <span v-else>{{ $route.meta.displayName }}</span>
      </v-toolbar-title>
      <template v-if="$_myUserData.isLoaded && !$_myUserData.isAuthed && !['login', 'logout'].includes($route.name)">
        <v-spacer class="d-none d-sm-block" />
        <v-btn
          depressed
          color="primary"
          :to="{ name: 'login' }"
          class="d-none d-sm-flex"
        >
          <v-icon
            size="20"
            class="mr-2"
          >
            fas fa-sign-in-alt
          </v-icon>
          <span>ログイン</span>
        </v-btn>
      </template>
    </v-app-bar>

    <v-content>
      <v-container>
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<style lang="scss">
* {
  touch-action: pan-x pan-y;
}
#app {
  i {
    margin: auto;
  }
  .container {
    margin-bottom: 100px;
  }
  .v-btn {
    text-transform: none;
  }
  .not-hover-btn::before {
    background-color: initial;
  }
  .mobile-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
  }
  .vue-notification-group {
    width: auto !important;

    .my-notification {
      @media (max-width:524px) {
        width: calc(100vw - 24px) !important;
      }
      .my-notification__text {
        white-space: pre-line;
      }
    }
  }
  .no-select-list::before {
    opacity: 0;
  }
  .no-select-list i {
    color: rgba(0, 0, 0, 0.54);
  }
}
</style>

<script>
export default {
  name: 'App',
  data: () => ({
    appDrawer: false,
    showTitlePages: ['playlist'],
    drawerTabs: [
      {
        title: 'ログイン',
        icon: 'fas fa-sign-in-alt',
        route: {
          name: 'login'
        },
        onlyPublic: true
      },
      {
        title: 'ホーム',
        icon: 'fa-home',
        route: {
          name: 'home'
        }
      },
      {
        title: '配信',
        icon: 'fas fa-broadcast-tower',
        route: {
          name: 'stream'
        },
        requiresAuth: true
      },
      {
        title: 'マイページ',
        icon: 'fas fa-user',
        route: {
          name: 'user-page'
        },
        requiresAuth: true
      },
      {
        title: '設定',
        icon: 'fas fa-cog',
        route: {
          name: 'settings'
        },
        requiresAuth: true
      },
      {
        title: '当サイトについて',
        icon: 'fas fa-file-alt',
        route: {
          name: 'about'
        }
      },
      {
        title: 'ログアウト',
        icon: 'fas fa-sign-out-alt',
        route: {
          name: 'logout'
        },
        requiresAuth: true
      }
    ]
  }),
  watch: {
    $route(to) {
      this.$_createPageTitle(to.meta);
    }
  },
  mounted() {
    this.$_createPageTitle(this.$route.meta);
  }
};
</script>
